import { all, put, takeLatest } from "redux-saga/effects";
import request from "redux/network/actions";
import { actions } from "./actions";
// eslint-disable-next-line import/named
import { dashboard } from "./api";

function* LOAD(payload) {
  yield put(request(dashboard(payload.payload), actions.LOAD));
}

export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, LOAD)]);
}
